.icon {
    transform: translateY(-1px); /*  Make icon with tail look centered */
}
